function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7396 3.58646L14.12 5.20609L10.7939 1.88007L12.4136 0.26044C12.4964 0.177759 12.5947 0.112215 12.7029 0.0675513C12.8111 0.0228881 12.927 -1.81164e-05 13.0441 0.000142298C13.1614 -0.00199699 13.2779 0.0200053 13.3864 0.0647832C13.4948 0.109561 13.5929 0.176158 13.6746 0.26044L15.7396 2.32546C15.8223 2.40831 15.8878 2.50663 15.9325 2.61481C15.9771 2.723 16.0001 2.83892 15.9999 2.95596C16.002 3.07329 15.98 3.18979 15.9353 3.29826C15.8905 3.40672 15.8239 3.50482 15.7396 3.58646V3.58646Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 12.6675L9.83346 2.83984L13.1595 6.16587L3.33181 15.9993H0V12.6675Z",
  fill: "currentColor"
});

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5da65351.svg";
export { ForwardRef as ReactComponent };